// require all angular template files in modules folder for the cache.
// This is to make it so you can `ng-include` templates without making new requests
// this is all very hacky. Might be better to just manually include some specific templates
const requirer = require.context("./", true, /\.html$/);
export function addTemplatesToCache(angularModule) {
  angularModule.run($templateCache => {
    for (const k of requirer.keys()) {
      const result = requirer(k);
      const rootRelative = k.replace(/^\.\//, "angularModules/"); 
      $templateCache.put(rootRelative, result);
    }
  });
}
